module.exports = __webpack_public_path__ + "media/img/corporate/job-add-c03e0aa4e90b003d15528dddc8f7d1a9.png";